// extracted by mini-css-extract-plugin
module.exports = {"payment-button":"PaymentCapture_payment-button__1XQFQ","form-messages":"PaymentCapture_form-messages__2uW7X","credit-card-icon":"PaymentCapture_credit-card-icon__1HycA"};